import { useGetAdministrativeUnitDetailQuery } from "services";

export function useAdministrativeUnitDetailed(administrativeUnitId: number) {
    const { data: administrativeUnitRes, isLoading } = useGetAdministrativeUnitDetailQuery(administrativeUnitId, {
        skip: !administrativeUnitId,
        refetchOnMountOrArgChange: true
    });

    return {
        administrativeUnit: administrativeUnitRes?.data,
        isLoading
    };
}